import { useCallback } from 'react'
import { emporionToast as toast } from '@admin/toast'
import type { Slide } from '../../../types'
import { EMPTY_SLIDE } from '../constants'
import { fetchSlidesSnapshot } from '../slidesApi'
import { toSlideForm } from './helpers'
import type { SlidesCrudArgs } from './useSlidesCrudActions.types'

type LoadArgs = Pick<
  SlidesCrudArgs,
  'setLoading' | 'setSlides' | 'setSlideForm' | 'setEditingId' | 'setSection' | 't'
>

export const useSlidesCrudLoadActions = ({
  setLoading,
  setSlides,
  setSlideForm,
  setEditingId,
  setSection,
  t,
}: LoadArgs) => {
  const loadSlides = useCallback(async () => {
    setLoading(true)
    try {
      const parsed = await fetchSlidesSnapshot({ t })
      if (!parsed.length) {
        toast(t('slider.toast.empty'), {
          icon: 'ℹ️',
        })
      }
      setSlides(parsed)
    } catch {
      toast.error(t('slider.toast.loadError'))
    } finally {
      setLoading(false)
    }
  }, [setLoading, setSlides, t])

  const resetSlideForm = useCallback(() => {
    setSlideForm(EMPTY_SLIDE)
    setEditingId(null)
  }, [setEditingId, setSlideForm])

  const selectForEdit = useCallback(
    (slide: Slide) => {
      setEditingId(slide.id)
      setSlideForm(toSlideForm(slide))
      setSection('slider')
    },
    [setEditingId, setSection, setSlideForm],
  )

  return {
    loadSlides,
    resetSlideForm,
    selectForEdit,
  }
}
